<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.503 5.837v13.617H4.87V5.837h13.633zm0-1.945H4.87a1.952 1.952 0 0 0-1.948 1.945v13.617c0 1.07.876 1.946 1.948 1.946h13.633a1.952 1.952 0 0 0 1.948-1.946V5.837c0-1.07-.877-1.945-1.948-1.945z" fill="#253E80"/>
    <path d="M13.637 17.509H6.82v-1.945h6.817v1.945zm2.922-3.89H6.82v-1.946h9.739v1.945zm0-3.891H6.82V7.782h9.739v1.946z" fill="#253E80"/>
  </svg>
</template>
